/**
 * Schnitt (Schriftstärke) von Texten, die heute mehrere Stärken haben — Frage
 * (Abstimmung, Bewertung, Reaktion) und Infografik.
 *
 * Jans Regel vom 07.10.2026 („Grundtext, Fettes bleibt“): Der gewählte Schnitt
 * gilt für den GRUNDTEXT (Antworten, Textfeld, Beschriftungen, Achsen). Was
 * heute kräftiger gezeichnet wird (Frage, Überschrift, Werte, gewählte Antwort,
 * Danke-Zeile), bleibt kräftiger — wird aber nie dünner als der Grundtext.
 * Beispiel: Light → Antworten Light, Frage weiter Bold; Black → alles Black.
 *
 * Ohne gewählten Schnitt zeichnet alles wie bisher.
 */

/** Ein Schnitt zwischen 100 und 900 (auf Hunderter gerundet), sonst `undefined`. */
export function gueltigerSchnitt(wert: unknown): number | undefined {
    if (typeof wert !== "number" || !Number.isFinite(wert)) return undefined;
    const gerundet = Math.round(wert / 100) * 100;
    return gerundet >= 100 && gerundet <= 900 ? gerundet : undefined;
}

/** Grundtext: der gewählte Schnitt, sonst die bisherige Stärke. */
export function grundSchnitt(gewaehlt: number | null | undefined, bisher: number): number {
    return gueltigerSchnitt(gewaehlt) ?? bisher;
}

/** Hervorhebung: bleibt bei ihrer Stärke, wird aber nie dünner als der Grundtext. */
export function betonterSchnitt(gewaehlt: number | null | undefined, bisher: number): number {
    return Math.max(bisher, gueltigerSchnitt(gewaehlt) ?? 0);
}
